export default {
  ECS1_TYPE_LOGEMENT0: 'Logements standards Habitat social',
  ECS1_TYPE_LOGEMENT1: 'Logements standards Habitat privé',
  ECS1_TYPE_LOGEMENT2: 'Type de logements social',
  ECS1_TYPE_LOGEMENT3: 'Type de logements privé',
  RLogementCompoEHPAD_T11: 'Studio ou appartement du résident',
  RLogementCompoEHPAD_T21: 'T2 (une douche)',
  RLogementCompoEHPAD_T31: 'T3 (appartement standard une baignoire)',
  RLogementCompoEHPAD_T32: 'T3 (une baignoire et une douche)',
  RLogementCompoEHPAD_T41: 'T4 (une baignoire)',
  RLogementCompoEHPAD_T42: 'T4 (une baignoire et une douche)',
  RCompostionFoyerStandard_T11: 'T1',
  RCompostionFoyerStandard_T21: 'T2 une occupant',
  RCompostionFoyerStandard_T23: 'T2 deux occupants',
  RCompostionFoyerStandard_T34: 'T3/T4 trois ou quatre occupants',
  RCompostionFoyerStandard_T56: 'T5/T6 cinq ou six occupants',
  S08I00_VASE1: 'Vase au refoulement des pompes de charges',
  S08I00_VASE2: 'Vase en amont des pompes chauffages',
  RAdoucisseurDiametreDebit_NOTFOUND: 'Aucun adoucisseur trouvé',
  I13VENTCHAUFGAZ_VENTILATION_0: 'Ventilation avec comburant par gaine',
  I13VENTCHAUFGAZ_VENTILATION_1: 'Ventilation avec comburant par paroi',
  I13VENTCHAUFGAZ_VENTILATION_2: 'Ventilation seule par gaine',
  I13VENTCHAUFGAZ_VENTILATION_3: 'Ventilation seule par paroi',
  I13VENTCHAUFGAZ_FORME_0: 'Ouverture rectangulaire',
  I13VENTCHAUFGAZ_FORME_1: 'Ouverture circulaire',
  I13VENTCHAUFGAZ_FORME_2: 'Ouverture carré',
  I13VENTCHAUFBOIS_FORME_0: 'Forme carré',
  I13VENTCHAUFBOIS_FORME_1: 'Forme rectangulaire',
  I13VENTCHAUFBOIS_FORME_2: 'Forme circulaire',
  murs_0: 'Très bon',
  murs_1: 'Bon',
  murs_2: 'Moyen',
  murs_3: 'Mauvais',
  plafond_0: 'Bien Isolé',
  plafond_1: 'Faiblement Isolé',
  plafond_2: 'Non Isolé',
  plancher_0: 'Bien Isolé',
  plancher_1: 'Faiblement Isolé',
  plancher_2: 'Non Isolé',
  config_0: 'Seul',
  config_1: 'Mitoyen',
  config_2: '2 étages',
  config_3: '2 étages Mitoyen',
  vitrage_0: 'Double Neuf',
  vitrage_1: 'Double Ancien',
  vitrage_2: 'Simple',
  orientation_N: 'Nord',
  orientation_NE: 'Nord-Est',
  orientation_E: 'Est',
  orientation_SE: 'Sud-Est',
  orientation_S: 'Sud',
  orientation_SO: 'Sud-Ouest',
  orientation_O: 'Ouest',
  orientation_NO: 'Nord-Ouest',
  pos_plancher_0: 'Extérieur',
  pos_plancher_1: 'Sur vide sanitaire',
  pos_plancher_2: 'Sur terre plein',
  pos_plancher_3: 'Sur cave enterrée',
  pos_plafond_0: 'Extérieur',
  pos_plafond_1: 'Sous comble non isolé',
  pos_plafond_2: 'Sous comble isolé'
}
